import React, { Fragment, useState, useEffect } from "react";
import {
  CalendarIcon,
  CheckIcon,
  CogIcon,
  DownloadIcon,
  SearchIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import {
  Form,
  Button,
  InputGroup,
  Dropdown,
  Nav,
  Card,
  Table,
  Pagination,
  Tab,
} from "react-bootstrap";
import {
  useCampaignSummaryReportsMutation,
  useCDRDetailsMutation,
  useChannelOverviewMutation,
  useCostBillingWAMutation,
  useDnld_WA_CDRMutation,
  useDnldCampMutation,
  useDnldChannelInsightsMutation,
  useDnldCostBillingMutation,
  useDnldErrorCodesMutation,
  useDnldScheduledCampMutation,
  useDnldWAUserMangMutation,
  useErrorCodeSummaryMutation,
  useScheduledCampMutation,
  useUserEngagementMutation,
} from "Services/services";
import Select from "react-select";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import hasPermission from "pages/Permissions";
import { downloadBlobFile } from "components/Utility";

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: "btn btn-secondary me-3",
      cancelButton: "btn btn-gray",
    },
    buttonsStyling: false,
  })
);

export default () => {
  // Get the user type from localStorage :: UI
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userID = userObject.id;

  // affects API response as well as data Table
  const [tabType, setTabType] = useState("tab1");

  // const [showToast, setShowToast] = useState(false);
  // const [toastMessage, setToastMessage] = useState('');
  // const [toastVariant, setToastVariant] = useState('success');

  const [tableData, setTableData] = useState([]);

  // const [bulkOption, setBulkOption] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  // const [filterOptions, setFilterOptions] = useState([]);
  // const [filterValue, setFilterValue] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [statusValue, setStatusValue] = useState("");

  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [CampaignList] = useCampaignSummaryReportsMutation();
  const [channelInsights] = useChannelOverviewMutation();
  const [errorCodes] = useErrorCodeSummaryMutation();
  const [viewCDR] = useCDRDetailsMutation();
  const [userEng] = useUserEngagementMutation();
  const [costBills] = useCostBillingWAMutation();
  const [scheduled] = useScheduledCampMutation();
  const [dnldCamp] = useDnldCampMutation();
  const [dnldChannelInsight] = useDnldChannelInsightsMutation();
  const [dnldCDRreport] = useDnld_WA_CDRMutation();
  const [dnldErrorCodes] = useDnldErrorCodesMutation();
  const [dnldUser] = useDnldWAUserMangMutation();
  const [dnldCost] = useDnldCostBillingMutation();
  const [dnldScheduled] = useDnldScheduledCampMutation();


  const getStatusOptions = (tabType) => {
    switch (tabType) {
      // case ("tab1"):
      //   return [
      //     { value: "delivered", label: "Delivered" },
      //     { value: "failed", label: "Failed" },
      //     { value: "read", label: "Read" }
      //   ];
      case ("tab3"):
        return [
          { value: "read", label: "Read" },
          { value: "failed", label: "Failed" },
          { value: "delivered", label: "Delivered" },
          { value: "Successfully Accepted", label: "Successfully Accepted" }
        ];
      // case "tab6":
      //   return [
      //     { value: "approved", label: "Approved" },
      //     { value: "rejected", label: "Rejected" },
      //     { value: "pending", label: "Pending" }
      //   ];
      case "tab8":
        return [
          { value: "pending", label: "Pending" },
          { value: "paused", label: "Paused" },
          { value: "cancelled", label: "Cancelled" },
          { value: "approved", label: "Approved" },
          { value: "rejected", label: "Rejected" },
          { value: "inprocess", label: "In-Process" },
          { value: "running", label: "Running" },
          { value: "completed", label: "Completed" },
        ];
      default:
        return [];
    }
  };

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 2000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const fetchCampaign = async () => {
    try {
      const response = await CampaignList({
        page: currentPage,
        limit: pagelimit,
        search: searchValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        campaignType: "WhatsApp",
      });

      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.items || []);
        setTotalPages(Math.ceil(response?.data?.data?.totalItems / pagelimit));
        setTotalPosts(response?.data?.data?.totalItems || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      alert(error.message);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };
  const fetchChannelInsights = async () => {
    try {
      const response = await channelInsights({
        user_id: userID,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      });
      if (response?.data?.statusCode === 200) {
        const obj = response?.data?.data?.whatsappPercentage || {};
        setTableData([obj]);
        setTotalPages("1");
        setTotalPosts("1");
      }
      else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };
  const fetchErrorCodes = async () => {
    try {
      const response = await errorCodes({
        campaignType: "WhatsApp",
        page: currentPage,
        limit: pagelimit,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        search: searchValue
      });

      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.items || []);
        setTotalPages(Math.ceil(response?.data?.data?.totalItems / pagelimit));
        setTotalPosts(response?.data?.data?.totalItems || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      alert(error.message);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };
  const fetchCDRs = async () => {
    try {
      const response = await viewCDR({
        mode: "whatsapp",
        search: searchValue,
        status: statusValue,
        page: currentPage,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        limit: pagelimit
      });
      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.items || []);
        setTotalPages(Math.ceil(response?.data?.data?.totalItems / pagelimit));
        setTotalPosts(response?.data?.data?.totalItems || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      alert(error.message);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };
  const fetchUserEngagement = async () => {
    try {
      const response = await userEng({
        page: currentPage,
        limit: pagelimit,
        msisdn: searchValue,
      });

      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.items || []);
        setTotalPages(Math.ceil(response?.data?.data?.totalItems / pagelimit));
        setTotalPosts(response?.data?.data?.totalItems || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      alert(error.message);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };
  const fetchCostBills = async () => {
    try {
      const response = await costBills({
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        page: currentPage,
        limit: pagelimit,
      });

      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.response?.items || []);
        setTotalPages(Math.ceil(response?.data?.data?.response?.totalItems / pagelimit));
        setTotalPosts(response?.data?.data?.response?.totalItems || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      alert(error.message);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };
  const fetchScheduled = async () => {
    try {
      const response = await scheduled({
        page: currentPage,
        limit: pagelimit,
        campaignType: "WhatsApp",
        search: searchValue,
        status: statusValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      });

      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.items || []);
        setTotalPages(Math.ceil(response?.data?.data?.totalItems / pagelimit));
        setTotalPosts(response?.data?.data?.totalItems || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      alert(error.message);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };
  const dnldCampaign = async () => {
    try {
      const blob = await dnldCamp({
        campaignType: "WhatsApp",
        search: searchValue,
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      }).unwrap();
      downloadBlobFile(blob, "WhatsAppp_Campaigns.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };
  const dnldCDR = async () => {
    try {
      const blob = await dnldCDRreport({
        search: searchValue,
        status: statusValue,
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      }).unwrap();
      downloadBlobFile(blob, "WhatsApp_CDRs.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };
  const dnldChannelIns = async () => {
    try {
      const blob = await dnldChannelInsight({
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      }).unwrap();
      downloadBlobFile(blob, "WhatsAppp_Channel_Insights.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };
  const dnldError = async () => {
    try {
      const blob = await dnldErrorCodes({
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
        campaignType: "WhatsApp",
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        search: searchValue
      }).unwrap();
      downloadBlobFile(blob, "WhatsAppp_Error_Report.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };
  const dnldUserManage = async () => {
    try {
      const blob = await dnldUser({
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        msisdn: searchValue,
        status: statusValue,
      }).unwrap();
      downloadBlobFile(blob, "WhatsAppp_User_Engagement.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };
  const dnldCostBilling = async () => {
    try {
      const blob = await dnldCost({
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      }).unwrap();
      downloadBlobFile(blob, "WhatsAppp_Billing_Report.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };
  const dnldScheduledCamps = async () => {
    try {
      const blob = await dnldScheduled({
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
        search: searchValue,
        campaignType: "WhatsApp",
        status: statusValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      }).unwrap();
      downloadBlobFile(blob, "WhatsAppp_Scheduled_Campaigns.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  useEffect(() => {
    if (tabType === "tab1") {
      fetchCampaign();
    }
    //  else if (tabType === "tab2") {
    //   fetchChannelInsights();
    // }
    else if (tabType === "tab3") {
      fetchCDRs();
    } else if (tabType === "tab4") {
      fetchErrorCodes();
    } else if (tabType === "tab5") {
      fetchUserEngagement();
    } else if (tabType === "tab7") {
      fetchCostBills();
    } else if (tabType === "tab8") {
      fetchScheduled();
    }
  }, [
    currentPage,
    pagelimit,
    debouncedValue,
    start,
    end,
    statusValue,
    tabType,
  ]);

  useEffect(() => {
    setPagelimit(10);
    setCurrentPage(1);
    setSearchValue('');
    setDebouncedValue('');
    setStart('');
    setEnd('');
    setStatusOptions(getStatusOptions(tabType));
    setTotalPages(0);
    setTotalPosts(0);
  }, [tabType]);

  const changeSearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  const downloadList = (ids) => { };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const canDownload = hasPermission("WhatsApp Reports", "download");
  const handleDownload = () => {
    if (tabType === "tab1") {
      dnldCampaign();
    }
    // else if (tabType === "tab2") {
    //   dnldChannelIns();
    // } 
    else if (tabType === "tab3") {
      dnldCDR();
    } else if (tabType === "tab4") {
      dnldError();
    } else if (tabType === "tab5") {
      dnldUserManage();
    } else if (tabType === "tab7") {
      dnldCostBilling();
    } else if (tabType === "tab8") {
      dnldScheduledCamps();
    } else {
      return;
    }
  }

  const TableRow = (props) => {

    switch (tabType) {
      case "tab1": {
        return (
          <tr className="border-bottom">
            <td><span className="fw-normal" title={props.campaign_id}>{props.campaign_id}</span></td>
            <td><span className="fw-normal" title={props.campaign_name}>{props.campaign_name}</span></td>
            <td><span className="fw-normal" title={props.waba_mobile}>{props.waba_mobile}</span></td>
            <td><span className="fw-normal" title={props.template_name}>{props.template_name}</span></td>
            <td><span className="fw-normal">{props.totalSubmitted}</span></td>
            <td><span className="fw-normal">{props.totalSuccess}</span></td>
            <td><span className="fw-normal">{props.totalRead}</span></td>
            <td><span className="fw-normal">{props.totalFailure}</span></td>
            <td><span className="fw-normal">{moment(props.time).format('DD/MM/YYYY') || '-'}</span></td>
            <td><span className="fw-normal">{props.totalDeductAmount}</span></td>
          </tr>
        );
      }
      // case "tab2":
      //   {
      //     return (
      //       <tr className="border-bottom">
      //         <td><span className="fw-normal">{props.submitted + '%' || '-'}</span></td>
      //         <td><span className="fw-normal">{props.failure + '%' || '-'}</span></td>
      //         <td><span className="fw-normal">{props.success + '%' || '-'}</span></td>
      //         <td><span className="fw-normal">{props.read + '%' || '-'}</span></td>
      //         <td><span className="fw-normal">{props.processing + '%' || '-'}</span></td>
      //       </tr>
      //     );
      //   }
      case "tab3":
        const getComponentsText = (componentsStr) => {
          if (!componentsStr) return '-';
        
          try {
            const parsed = JSON.parse(componentsStr);
        
            return parsed.components
              .map(c => c.text)
              .join(" ")
              .trim();
          } catch (err) {
            return componentsStr; // fallback to raw string
          }
        };
        {
          return (
            <tr className="border-bottom">
              <td><span className="fw-normal " title={props.campaign_name || '-'}>{props.campaign_name || '-'}</span></td>
              <td><span className="fw-normal " title={props.msisdn || '-'}>{props.msisdn || '-'}</span></td>
              <td>
                <div className="d-block">
                  <span className="fw-bold text-info">{props.template_id}</span>
                  <div className="small text-gray">Language: {props.language}</div>
                </div>
              </td>
              <td><span className="fw-normal " title={props.code || '-'}>{props.code || '-'}</span></td>
              <td><span className="fw-normal">{moment(props.campaign_start_at).format('DD/MM/YYYY') || '-'}</span></td>
              <td><span className="fw-normal">{moment(props.message_time).format('DD/MM/YYYY') || '-'}</span></td>
              <td><span className="fw-normal " title={props.created_by || '-'}>{props.created_by || '-'}</span></td>
              <td><span className="fw-normal">{props.sell_price || '-'}</span></td>
              <td><span className="fw-normal " title={props.status || '-'}>{props.status || '-'}</span></td>
              <td><span className="fw-normal " title={getComponentsText(props.components) || '-'}>{getComponentsText(props.components) || '-'}</span></td>
            </tr>
          );
        }
      case "tab4":
        {
          return (
            <tr className="border-bottom">
              <td><span className="fw-normal " title={props.code || '-'}>{props.code || '-'}</span></td>
              <td><span className="fw-normal">{props.totalCount || '-'}</span></td>
              <td><span className="fw-normal">{moment(props.createdAt).format('DD/MM/YYYY') || '-'}</span></td>
              <td><span className="fw-normal">{props.totalDeductAmount || '-'}</span></td>
            </tr>
          );
        }
      case "tab5":
        {
          return (
            <tr className="border-bottom">
              <td><span className="fw-normal" title={props.msisdn || '-'}>{props.msisdn || '-'}</span></td>
              <td><span className="fw-normal">{props.totalSubmitted || '-'}</span></td>
              <td><span className="fw-normal">{props.totalSuccess || '-'}</span></td>
              <td><span className="fw-normal">{props.totalFailure || '-'}</span></td>
              <td><span className="fw-normal">{props.totalRead || '-'}</span></td>
            </tr>
          );
        }
      case "tab7":
        {
          return (
            <tr className="border-bottom">
              <td><span className="fw-normal">{moment(props.time).format('DD/MM/YYYY') || '-'}</span></td>
              <td><span className="fw-normal">{props.totalSubmitted || '-'}</span></td>
              <td><span className="fw-normal">{props.totalDeductAmount || '-'}</span></td>
            </tr>
          );
        }
      case "tab8":
        {
          return (
            <tr className="border-bottom">
              <td><span className="fw-normal" title={props.campaign_id || '-'}>{props.campaign_id || '-'}</span></td>
              <td><span className="fw-normal" title={props.campaignName || '-'}>{props.campaignName || '-'}</span></td>
              <td><span className="fw-normal">{moment(props.scheduledTime).format('DD/MM/YYYY') || '-'}</span></td>
              <td><span className="fw-normal" title={props.actualSentTime || '-'}>{props.actualSentTime || '-'}</span></td>
              <td><span className="fw-normal" title={props.scheduled_type || '-'}>{props.scheduled_type || '-'}</span></td>
              <td><span className="fw-normal" title={props.status || '-'}>{props.status || '-'}</span></td>
            </tr>
          );
        }
      default: {
        return null;
      }
    }
  };

  return (
    <Fragment>
      <Card className="p-2">

        <Tab.Container
          defaultActiveKey={tabType}
          onSelect={(key) => {
            setTabType(key);
          }}
        >
          <Nav fill variant="pills" className="flex-xl-nowrap gap-2">
            <Nav.Item>
              <Nav.Link eventKey="tab1">Campaign Overview</Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
                <Nav.Link eventKey="tab2">Channel Insights</Nav.Link>
              </Nav.Item> */}
            <Nav.Item>
              <Nav.Link eventKey="tab3">CDR Report</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="tab4">Error Report</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="tab5">User Engagement Report</Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
                <Nav.Link eventKey="tab6">Template Performance Report</Nav.Link>
              </Nav.Item> */}
            <Nav.Item>
              <Nav.Link eventKey="tab7">Cost & Billing Report</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="tab8">Scheduled Campaign Log</Nav.Link>
            </Nav.Item>
          </Nav>
        </Tab.Container>
      </Card>

      <Card border={1}>
        <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
          {tabType !== "tab2" && tabType !== "tab7" && <InputGroup className="d-flex flex-nowrap fmxw-500">
            <InputGroup.Text>
              <SearchIcon className="icon icon-xs" />
            </InputGroup.Text>
            <Form.Control
              type="search"
              placeholder={
                tabType === "tab1" ? "Search Campaign ID/Campaign Name" :
                  tabType === "tab3" ? "Search Campaign Name/MSISDN" :
                    tabType === "tab4" ? "Search Error Code" :
                      tabType === "tab5" ? "Search MSISDN" :
                        // tabType === "tab6" ? "Search Template ID/Template Name" :
                        tabType === "tab8" ? "Search Campaign ID/Campaign Name" : "Search"
              }
              value={searchValue}
              onChange={changeSearchValue}
            />
          </InputGroup>}
          {tabType !== "tab2" && tabType !== "tab5" && 
           <Form.Group id="DateRange">
           <InputGroup className="d-flex flex-nowrap">
             <InputGroup.Text
               onClick={() => {
                 setStart(null);
                 setEnd(null);
               }}
             >
               {start || end ? (
                 <XCircleIcon className="icon icon-xs" />
               ) : (
                 <CalendarIcon className="icon icon-xs" />
               )}
             </InputGroup.Text>
             <Datetime
               timeFormat={false}
               onChange={(date) => {
                 if (moment.isMoment(date)) {
                   setStart(date);
                 }
               }}
               closeOnSelect={true}
               renderInput={(props, openCalendar) => (
                 <Form.Control
                   type="search"
                   placeholder="Start Date"
                   value={
                     start ? moment(start).format("DD/MM/YYYY") : ""
                   }
                   onFocus={openCalendar}
                   readOnly
                   style={{ width: "150px", borderRadius: "0" }}
                 />
               )}
             />
             <Datetime
               timeFormat={false}
               onChange={(date) => {
                 if (moment.isMoment(date)) {
                   setEnd(date);
                 }
               }}
               closeOnSelect={true}
               isValidDate={(currDate) => currDate.isAfter(start)}
               initialViewDate={end}
               renderInput={(props, openCalendar) => (
                 <Form.Control
                   type="search"
                   placeholder="End Date"
                   value={end ? moment(end).format("DD/MM/YYYY") : ""}
                   onFocus={openCalendar}
                   readOnly
                   style={{
                     width: "150px",
                     borderTopLeftRadius: "0",
                     borderBottomLeftRadius: "0",
                   }}
                 />
               )}
             />
           </InputGroup>
         </Form.Group>
          }

          {tabType !== "tab1" && tabType !== "tab2" && tabType !== "tab4" && tabType !== "tab5" && tabType !== "tab7" && (
            <div style={{ minWidth: 200 }} className="fix-200">
              <Select
                options={statusOptions}
                value={statusOptions.find(option => option.value === statusValue) || null}
                onChange={option => setStatusValue(option ? option.value : "")}
                isClearable
                placeholder="Select Status"
              />
            </div>
          )}

          <div className="ms-auto d-inline-flex gap-2">
            {canDownload && (
              <Button
                variant="outline-gray-300"
                className="p-2"
                onClick={handleDownload}
              >
                <DownloadIcon className="icon icon-sm" />
              </Button>
            )}

            <Dropdown>
              <Dropdown.Toggle
                split
                as={Button}
                variant="outline-gray-300"
                className="text-dark m-0 p-2"
              >
                <CogIcon className="icon icon-sm" />
                <span className="visually-hidden">
                  Toggle Dropdown
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
                <span className="small ps-2 fw-bold text-dark">
                Rows per page
                </span>
                {[10, 20, 30].map((limit) => (
                  <Dropdown.Item
                    key={limit}
                    className={`d-flex align-items-center fw-bold ${limit === 30 ? "rounded-bottom" : ""
                      }`}
                    onClick={() => {
                      setPagelimit(limit); // Update the page limit
                      setCurrentPage(1); // Reset the page number to 1
                    }}
                  >
                    {limit}{" "}
                    {pagelimit === limit && (
                      <CheckIcon className="icon icon-xxs ms-auto" />
                    )}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <div className="custom-scroll-wrapper">
          <div className="scroll-container">
            <Table responsive className="align-items-center table-flush table-outlines">
              <thead className="thead-light">
                {tabType === 'tab1' ?
                  <tr>
                    <th className="border-bottom">Campaign ID</th>
                    <th className="border-bottom">Campaign Name</th>
                    <th className="border-bottom">WABA ID</th>
                    <th className="border-bottom">Template Name</th>
                    <th className="border-bottom">Total Sent</th>
                    <th className="border-bottom">Delivered</th>
                    <th className="border-bottom">Read</th>
                    <th className="border-bottom">Failed</th>
                    <th className="border-bottom" style={{minWidth:'120px'}}>Date</th>
                    <th className="border-bottom">Cost</th>
                  </tr>
                  //  : tabType === 'tab2' ?
                  //   <tr>
                  //     <th className="border-bottom">Submitted</th>
                  //     <th className="border-bottom">Failure</th>
                  //     <th className="border-bottom">Success</th>
                  //     <th className="border-bottom">Read</th>
                  //     <th className="border-bottom">In-Process</th>
                  //   </tr>
                  : tabType === 'tab3' ?
                    <tr>
                      <th className="border-bottom">Campaign Name</th>
                      <th className="border-bottom">MSISDN</th>
                      <th className="border-bottom">Template</th>
                      <th className="border-bottom">Code</th>
                      <th className="border-bottom">Campaign Run-Time</th>
                      <th className="border-bottom">Delivery Time</th>
                      <th className="border-bottom">Created By</th>
                      <th className="border-bottom">Cost</th>
                      <th className="border-bottom">Status</th>
                      <th className="border-bottom">Content</th>
                    </tr> : tabType === 'tab4' ?
                      <tr>
                        <th className="border-bottom">Code</th>
                        <th className="border-bottom">Total Count</th>
                        <th className="border-bottom">Created On</th>
                        <th className="border-bottom">Deducted Amount</th>
                      </tr> : tabType === 'tab5' ?
                        <tr>
                          <th className="border-bottom">MSISDN</th>
                          <th className="border-bottom">Total Submitted</th>
                          <th className="border-bottom">Total Success</th>
                          <th className="border-bottom">Total Failed</th>
                          <th className="border-bottom">Total Read</th>
                        </tr>
                        // : tabType === 'tab6' ?
                        //   <tr>
                        //     <th className="border-bottom">Template ID</th>
                        //     <th className="border-bottom">Name</th>
                        //     <th className="border-bottom">Total Used</th>
                        //     <th className="border-bottom">Delivered</th>
                        //     <th className="border-bottom">Failed</th>
                        //     <th className="border-bottom">Last Used</th>
                        //   </tr> 
                        : tabType === 'tab7' ?
                          <tr>
                            <th className="border-bottom">Date</th>
                            <th className="border-bottom">Total Sent</th>
                            <th className="border-bottom">Total Cost</th>
                          </tr> : tabType === 'tab8' ?
                            <tr>
                              <th className="border-bottom">Campaign ID</th>
                              <th className="border-bottom">Campaign Name</th>
                              <th className="border-bottom">Scheduled Date</th>
                              <th className="border-bottom">Scheduled Time</th>
                              <th className="border-bottom">Scheduled Type</th>
                              <th className="border-bottom">Status</th>
                            </tr> : ""}
              </thead>
              <tbody className="border-0">
                {tableData.length > 0 ? (
                  tableData.map((u, index) => (
                    <TableRow key={index + 1} index={index + 1} {...u} />
                  ))
                ) : (
                  <tr>
                    <td colSpan={tabType === 'tab1' ? 10 : (tabType === 'tab2' || tabType === 'tab4' || tabType === 'tab5' ) ? 5 : (tabType === 'tab6'|| tabType === 'tab8') ? 6 : (tabType === 'tab7') ? 4 : 10} className="text-center text-danger">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <Card.Footer className="p-0 mt-3 border-0 d-flex flex-wrap align-items-center justify-content-between">
          <Nav>
            <Pagination className="mb-0">
              <Pagination.Prev
                onClick={handlePrev}
                disabled={currentPage === 1}
              >
                Previous
              </Pagination.Prev>
              {currentPage >= 3 && (
                <>
                  <Pagination.Item onClick={() => handlePageChange(1)}>
                    1
                  </Pagination.Item>
                  <Pagination.Ellipsis />
                </>
              )}
              {currentPage > 1 && (
                <Pagination.Item
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  {currentPage - 1}
                </Pagination.Item>
              )}
              <Pagination.Item active>{currentPage}</Pagination.Item>
              {currentPage < totalPages && (
                <Pagination.Item
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  {currentPage + 1}
                </Pagination.Item>
              )}
              {currentPage < totalPages - 1 && (
                <>
                  <Pagination.Ellipsis />
                  <Pagination.Item
                    onClick={() => handlePageChange(totalPages)}
                  >
                    {totalPages}
                  </Pagination.Item>
                </>
              )}
              <Pagination.Next
                onClick={handleNext}
                disabled={currentPage === totalPages}
              >
                Next
              </Pagination.Next>
            </Pagination>
          </Nav>
          <small className="fw-normal small mt-2 mt-md-0">
            Showing <b>{totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-{(pagelimit * currentPage) > totalPosts ? totalPosts : (pagelimit * currentPage)}</b> of <b>{totalPosts}</b>{" "}entries.
          </small>
        </Card.Footer>
      </Card >


    </Fragment >
  );
};